module.exports = __webpack_public_path__ + "static/media/VDVMNAEN0417_Assessing_Violence_in_the_Community_-_A_Handbook_for_the_Workplace_V2.0_04.26.2017.1d4f3692.pdf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/pdfs/VDVMNAEN0417_Assessing_Violence_in_the_Community_-_A_Handbook_for_the_Workplace_V2.0_04.26.2017.pdf
// module id = 1330
// module chunks = 0